module.exports = __webpack_public_path__ + "static/media/BuenosAiresWeb-Thin.811e9eb4.woff";